import React from 'react'
import Loader from '../../../components/Loader'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Responsive from '../../../assets/config/Responsive'
import Title from '../../../components/v2/Title'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../store'
import { CriticalIllnessState, setForWho, setInsured } from '../../../store/criticalIllnessSlice'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import api from '../../../api'
import { AppState } from '../../../store/appSlice'

const CriticalWhoDoYouInsure = () => {
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const dispatch = useAppDispatch()
  //
  const { checkout, filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-insurance-for-who')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  const listItems = pageInfo?.listItems?.slice().sort((a, b) => a.sort - b.sort)
  //
  // Check if at least one age is over 18
  const oneIsAdult = filter.insuredInfo && filter.insuredInfo?.map((x) => x.age)?.some((age) => age >= 18)
  //
  //
  const forMeBoolean =
    checkout?.forWho === 'for-me' && filter?.insuredInfo?.length === 1 && oneIsAdult === true ? false : true
  //
  const forOtherBoolean =
    checkout?.forWho === 'for-other' && filter?.insuredInfo && filter?.insuredInfo?.length >= 1 ? false : true
  //
  //
  const forMeAndOther =
    checkout?.forWho === 'for-me-and-other' &&
    filter?.insuredInfo &&
    filter?.insuredInfo?.length >= 2 &&
    oneIsAdult === true
      ? false
      : true
  //
  //
  const nextButtonValidation =
    checkout?.forWho === 'for-me'
      ? forMeBoolean
      : checkout?.forWho === 'for-other'
      ? forOtherBoolean
      : checkout?.forWho === 'for-me-and-other'
      ? forMeAndOther
      : true
  //
  //
  //
  const mainLoading = isPageInfoLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <Cards>
          {listItems &&
            listItems?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  disabled={false}
                  title={item?.translations?.[lang]?.title}
                  imgUrl={item?.image}
                  selected={item.type === checkout.forWho ? true : false}
                  onClick={() => {
                    dispatch(setForWho(item.type))
                    dispatch(setInsured(undefined))
                  }}
                ></HorizontalCard>
              )
            })}
        </Cards>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/critical-offer')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={nextButtonValidation}
            onClick={() => {
              navigate(
                checkout.forWho === 'for-me'
                  ? '/critical-for-me'
                  : checkout.forWho === 'for-other'
                  ? '/critical-for-other'
                  : checkout.forWho === 'for-me-and-other'
                  ? '/critical-for-me-and-other'
                  : '',
              )
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Cards = styled.div`
  margin-top: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 464px;
  width: 100%;
  gap: 24px;

  ${Responsive.mobile} {
    margin-top: 27px;
    min-width: unset;
  }
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  /*  */
`

export default CriticalWhoDoYouInsure
